<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Profile Name
          </div>
          <v-spacer/>
          <div class="mr-4 mt-4" v-if="this.getUser.basic.admin">
            <a :class="ui.textWarning">
            Admin
            </a>
          </div>
          <v-spacer/>
          <div class="ml-4 mr-4 mt-4">
            <DocumentStatus :data="{
              model: 'STD',
              rev: this.displayDocumentRevTypeA(getDetail.rev),
              sec: getDetail.rev.sec,
              stat: getDetail.rev.stat,
              type: getDetail.rev.type}
              "/>
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.nfirst"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="account_circle"
            hint="first name"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.nmid"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="contact_page"
            hint="middle name"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.npref"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="portrait"
            hint="preferred name"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.nlast"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="account_box"
            hint="last name"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Data
          </div>
          <v-spacer/>
          <div class="mr-0 mt-4">
            {{this.getUserStats.averify}}
          </div>
          <div class="ml-4 mr-4 mt-4">
            {{displayDocumentIDGTypeA(getDetailBasic.tag, getDetailBasic.idg)}}
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :label="displayDocumentID(this.getDetail.basic.did)"
            prepend-icon="fingerprint"
            hint="document id"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :label="displayDocumentID(this.getDetail.basic.idg)"
            prepend-icon="pin"
            hint="generated id"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :label="displayDocumentID(this.getDetail.basic.uid)"
            prepend-icon="person"
            hint="user id"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="userStatus"
            prepend-icon="verified_user"
            hint="status"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mr-2">
          <v-spacer/>
          <DataPrivacyCard class="hidden-xs-only" :data="{btnSize: 'icon'}"/>
          <TermsAndConditionsCard class="hidden-xs-only" :data="{btnSize: 'icon'}"/>
          <StatsReadCard :data="{tag: this.getDetail.basic.tag}"/>
          <StatsReadCardOpen :data="{tag: this.getDetail.basic.tag}"/>
          <RevisionReadCard v-if="this.getDetailBasic.tag !== 'G1'"/>
          <GetDocumentLogListPage :data="{size: 'icon'}"/>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import DocumentStatus from "@/document/revisions/components/DocumentStatus";
import GetDocumentLogListPage from "@/document/log/components/GetDocumentLogListPage";
import RevisionReadCard from "@/document/revisions/components/RevisionReadCard";
import StatsReadCard from "@/support/stats/components/StatsReadCard";
import StatsReadCardOpen from "@/support/stats/components/StatsReadCardOpen";
import DataPrivacyCard from "@/admin/privacy/components/DataPrivacyCard";
import TermsAndConditionsCard from "@/admin/tc/components/TermsAndConditionsCard";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        nfirst: "",
        nlast: "",
        nmid: "",
        npref: ""
      },
      orgForm: {
        nfirst: "",
        nlast: "",
        nmid: "",
        npref: ""
      }
    };
  },
  beforeMount() {
    // Prepare for doc log
    this.prepareForDocumentLog();
    // fix orginal data before change
    this.localForm.nfirst = this.getUser.char.nfirst;
    this.localForm.nlast = this.getUser.char.nlast;
    this.localForm.nmid = this.getUser.char.nmid;
    this.localForm.npref = this.getUser.char.npref;

    this.orgForm.nfirst = this.getUser.char.nfirst;
    this.orgForm.nlast = this.getUser.char.nfirst;
    this.orgForm.nmid = this.getUser.char.nfirst;
    this.orgForm.npref = this.getUser.char.nfirst;
  },
  mixins: [
    revFunctions,
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    docLogFunctions,
    displayFunctions
  ],
  components: {
    DocumentStatus,
    StatsReadCard,
    StatsReadCardOpen,
    RevisionReadCard,
    GetDocumentLogListPage,
    DataPrivacyCard,
    TermsAndConditionsCard
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getUserStats",
      "getDetailBasic",
      "getDetailChar"
    ]),
    userStatus() {
      let status = null;
      if (this.getUser.basic.act === true) {
        status = "Active";
      } else {
        status = "Not Active";
      }
      return status;
    }
  },
  methods: {
    updateFormChar() {
      // console.log(this.localForm.firstName);
      // console.log(this.localForm.firstName);
      let char = this.getDetailChar;
      if (
        this.localForm.firstName !== this.orgForm.firstName &&
        this.localForm.firstName !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.firstName = this.localForm.firstName;
        // basic
        char.firstName = this.localForm.firstName;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.11); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
